<template>
	<select @change='change' v-model="selected" class='form-control form-control my-control table-control' :disabled='disabled'>
		<option v-for="option in options" :value='option.id'>
			{{ option.name }}
		</option>
	</select>
</template>

<script>
	import {DB} from './../../../constants'
	const NPA_VIOLATION_NEW = 'get_npa_violation_new.php'

	import {EventBus} from '../../../lib/EventBus'

	export default {
		name: 'npaViolation',
		data: function () { 
			return {
				selected: '',
				options: [],
				internal_id: null
			}
		},
		props: {
			id: null,
			line_count: null,
			disabled: false
		},
		methods: {
			change () {
				EventBus.$emit(`npa_violation`, {index: this.$props.line_count, value: this.selected})
			}
		},
		created () {
			/*fetch(DB + NPA_VIOLATION_NEW, {
				credentials: 'include'
			})
			.then(data => data.json())
			.then(data => {
				if (data) {
					this.options = data
					this.selected = this.internal_id ? this.internal_id : data[0].id
					this.internal_id = null
				}
				else {
					this.options = []
				}
			})
			.catch(err => console.log(err))*/

			this.internal_id = this.$props.id
			if(this.$parent.npa_violations.length)
			{
				this.options = this.$parent.npa_violations
				this.selected = this.internal_id ? this.internal_id : this.options[0].id
				this.internal_id = null
			} else {
				EventBus.$on('fetch_npa_violations_complete', () => {
					this.options = this.$parent.npa_violations
					this.selected = this.internal_id ? this.internal_id : this.options[0].id
					this.internal_id = null
				})
			}
			
		}
	}
</script>


// WEBPACK FOOTER //
// npaViolation.vue?4957975d